export default "__VITE_ASSET__BvrQNSoS__"